import React, {Component} from 'react';

export default class TableRow extends Component {
  render() {
    return(
      <tr>
        <td>{this.props.month}</td>
        <td>{this.props.horizontal}</td>
        <td>{this.props.tilt}</td>
        <td>{this.props.maxtemp}</td>
        <td>{this.props.nosun}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TableRow/TableRow.js